const DATABASE_NAME = "lumen-tms-cache";
const DATABASE_VERSION = 1;
const STORE_NAME = "cache_entries";

const canUseIndexedDb = () => typeof window !== "undefined" && "indexedDB" in window;

const openCacheDatabase = () => new Promise((resolve, reject) => {
  if (!canUseIndexedDb()) {
    resolve(null);
    return;
  }
  const request = window.indexedDB.open(DATABASE_NAME, DATABASE_VERSION);
  request.onerror = () => reject(request.error || new Error("Unable to open IndexedDB cache."));
  request.onupgradeneeded = () => {
    const database = request.result;
    if (!database.objectStoreNames.contains(STORE_NAME)) {
      database.createObjectStore(STORE_NAME, { keyPath: "storageKey" });
    }
  };
  request.onsuccess = () => resolve(request.result);
});

const readRecord = async (storageKey) => {
  const database = await openCacheDatabase();
  if (!database) {
    return null;
  }
  return new Promise((resolve, reject) => {
    const transaction = database.transaction(STORE_NAME, "readonly");
    const request = transaction.objectStore(STORE_NAME).get(storageKey);
    request.onerror = () => reject(request.error || new Error("Unable to read IndexedDB cache."));
    request.onsuccess = () => resolve(request.result || null);
  });
};

export const loadIndexedCache = async (storageKey, maxAgeMs) => {
  if (!canUseIndexedDb()) {
    return null;
  }
  try {
    const record = await readRecord(storageKey);
    if (!record?.savedAt || typeof record.savedAt !== "number") {
      return null;
    }
    if (Date.now() - record.savedAt > maxAgeMs) {
      return null;
    }
    return record.data ?? null;
  } catch {
    return null;
  }
};

export const saveIndexedCache = async (storageKey, data) => {
  if (!canUseIndexedDb()) {
    return;
  }
  try {
    const database = await openCacheDatabase();
    if (!database) {
      return;
    }
    await new Promise((resolve, reject) => {
      const transaction = database.transaction(STORE_NAME, "readwrite");
      transaction.oncomplete = () => resolve();
      transaction.onerror = () => reject(transaction.error || new Error("Unable to write IndexedDB cache."));
      transaction.objectStore(STORE_NAME).put({ storageKey, savedAt: Date.now(), data });
    });
  } catch {
    // no-op
  }
};